// axios
import axios from 'axios'

const domain = ""

axios.defaults.headers.common.Accept = 'application/json;charset=UTF-8'
axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8'

export default axios.create({
    domain,
    baseURL: '/v1',
    // You can add your headers here
})